import * as constants from '../constants';
import { Message } from '../models';
export interface AddMessageRequest {
  type: constants.ADD_MESSAGE_REQUEST;
  message: string;
  tags: number[];
}

export interface AddMessageSuccess {
  type: constants.ADD_MESSAGE_SUCCESS;
  message: Message;
}

export interface AddMessageFailure {
  type: constants.ADD_MESSAGE_FAILURE;
  error: string;
}

export interface ShowAddMessageSection {
  type: constants.SHOW_ADD_MESSAGE_SECTION;
}

export interface HideAddMessageSection {
  type: constants.HIDE_ADD_MESSAGE_SECTION;
}

export const addMessageRequest = (message: string, tags: number[]): AddMessageRequest => {
  return {
    message,
    tags,
    type: constants.ADD_MESSAGE_REQUEST,
  };
};

export const addMessageSuccess = (message: Message): AddMessageSuccess => {
  return {
    message,
    type: constants.ADD_MESSAGE_SUCCESS,
  };
};

export const addMessageFailure = (error: string): AddMessageFailure => {
  return {
    error,
    type: constants.ADD_MESSAGE_FAILURE,
  };
};

export const showAddMessageSection = () : ShowAddMessageSection => {
  return {
    type: constants.SHOW_ADD_MESSAGE_SECTION,
  };
};

export const hideAddMessageSection = () : HideAddMessageSection => {
  return {
    type: constants.HIDE_ADD_MESSAGE_SECTION,
  };
};






// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/addMessage.ts